export default "__VITE_ASSET__Dx7a9Ygb__"